import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface AssociateEditor {
    _id: string;
    fullName: string;
    email: string;
}

interface AssociateEditorContextType {
    associateEditor: AssociateEditor | null;
    token: string | null;
    isAuthenticated: boolean;
    logout: () => void;
    loading: boolean;
}

const AssociateEditorContext = createContext<AssociateEditorContextType>({
    associateEditor: null,
    token: null,
    isAuthenticated: false,
    logout: () => { },
    loading: true
});

export const useAssociateEditor = () => useContext(AssociateEditorContext);

export const AssociateEditorProvider = ({ children }: { children: ReactNode }) => {
    const [associateEditor, setAssociateEditor] = useState<AssociateEditor | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('associateEditorToken');
        const storedAssociateEditor = localStorage.getItem('associateEditorData');

        if (storedToken && storedAssociateEditor) {
            setToken(storedToken);
            setAssociateEditor(JSON.parse(storedAssociateEditor));
        }

        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('associateEditorToken');
        localStorage.removeItem('associateEditorData');
        setAssociateEditor(null);
        setToken(null);
        // This role is embedded as a tab inside the unified dashboard, so logging out
        // here should return to the unified login, not this role's standalone one.
        window.location.href = '/login';
    };

    return (
        <AssociateEditorContext.Provider value={{
            associateEditor,
            token,
            isAuthenticated: !!token && !!associateEditor,
            logout,
            loading
        }}>
            {children}
        </AssociateEditorContext.Provider>
    );
};
